import { ACADEMIC_PERFORMANCE_EVALUATION_TYPES } from '@src/modules/evaluacion-desempeño-academico/domain/entities/Evaluation'
import EvaluationDetails from '../../evaluacion-desempeño-academico/domain/entities/EvaluationDetails'

class RespetoValoresPrincipios {
  constructor(id = null, detalles = new EvaluationDetails(), reactivos = []) {
    this.id = id
    this.tipo = ACADEMIC_PERFORMANCE_EVALUATION_TYPES.RESPECT_VALUES_AND_PRINCIPLES
    this.detalle = detalles
    this.reactivos = reactivos
  }

  static fromDto(respetoValoresPrincipiosDto) {
    const respetoValoresPrincipios = new RespetoValoresPrincipios(
      respetoValoresPrincipiosDto.id,
      {
        status: respetoValoresPrincipiosDto.fk_idCatEstatusEvaluacion,
        idMunicipio: respetoValoresPrincipiosDto.fk_idCatMunicipio,
        municipio: respetoValoresPrincipiosDto.CatMunicipio,
        idEvaluado: respetoValoresPrincipiosDto.fk_idPersonal,
        evaluado: { ...respetoValoresPrincipiosDto.Personal },
        idEvaluador: respetoValoresPrincipiosDto.fk_idPersonalEvaluador,
        evaluador: { ...respetoValoresPrincipiosDto.PersonalEvaluador },
        fechaAplicacion: respetoValoresPrincipiosDto.fechaAplicacion,
        fechaFin: respetoValoresPrincipiosDto.fechaFin,
        fechaInicial: respetoValoresPrincipiosDto.fechaInicial,
        idResultado: respetoValoresPrincipiosDto.fk_idResultado,
        institucionSeguridadAspirada: respetoValoresPrincipiosDto.institucionSeguridadAspira,
        puestoAspirado: respetoValoresPrincipiosDto.aspiranteAlPuesto,
        observaciones: respetoValoresPrincipiosDto.observaciones,
      },
      respetoValoresPrincipiosDto.frecuenciasMedicion.map((item) => ({
        id: item.id,
        idFrecuencia: item.fk_idCatFrecuencia,
        idReactivo: item.fk_idReactivoValor,
        estatus: true,
      }))
    )

    return { ...respetoValoresPrincipios }
  }
}

export default RespetoValoresPrincipios
